import { rootSelector } from './root.selector';
import { MPlayerState } from '../store.types';

const getCallToAction = rootSelector.callToAction;

export const callToActionSelector = {
  buttonStringPerPlayer(state: MPlayerState): string {
    return getCallToAction(state).ctaPerPlayer.buttonString;
  },
  urlPerPlayer(state: MPlayerState): string {
    return getCallToAction(state).ctaPerPlayer.url;
  },
  buttonStringPerVideo(state: MPlayerState): string {
    return getCallToAction(state).ctaPerVideo.buttonString;
  },
  urlPerVideo(state: MPlayerState): string {
    return getCallToAction(state).ctaPerVideo.url;
  },
};
